import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-left">
        <p className="section-label">About Maitreyee Goswami, Founder, Echo Communications</p>
        <h2 className="section-heading">"The gap between<br />vision and voice<br />is where we work."</h2>
        <div className="about-body">
          <p>After two decades shaping communications strategy for some of the world's most recognised brands, I now work exclusively with founders, CEOs, and CXOs who are building trust, influence and shaping perception at scale.</p>
          <p>My work sits at the intersection of narrative architecture, reputation management and executive visibility.</p>
          <p>Through my work and platform, I'm increasingly focused on a simple idea: Narrative drives perception. Perception drives outcomes. Get both right, and leadership becomes a force multiplier.</p>
        </div>
      </div>
      <div className="about-right">
        <div className="about-stat-grid">
          <div className="about-stat">
            <div className="about-stat-num">20<span>+</span></div>
            <div className="about-stat-label">Years in strategic communications</div>
          </div>
          <div className="about-stat">
            <div className="about-stat-num">6</div>
            <div className="about-stat-label">Critical industries — AI, Tech, Financial Services, Insurance, FMCG, Consumer Goods</div>
          </div>
          <div className="about-stat">
            <div className="about-stat-num">F500</div>
            <div className="about-stat-label">Category-defining Fortune 500 companies</div>
          </div>
          <div className="about-stat">
            <div className="about-stat-num">1</div>
            <div className="about-stat-label">Goal — Elevate executive communication</div>
          </div>
        </div>
        <div className="about-brands">
          <p className="about-brands-label">Previously</p>
          <div className="about-brands-list">
            <span>Microsoft</span>
            <span>American Express</span>
            <span>Prudential Financial</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
